import type { TooltipProps } from './Tooltip';
import { Tooltip } from './Tooltip';
import styles from './InfoTooltip.module.css';

export interface InfoTooltipProps {
  /** Texto que se muestra dentro del tooltip. */
  content: string;
  /** Etiqueta accesible del botón (el texto del campo al que acompaña). */
  label: string;
  position?: TooltipProps['position'];
}

/**
 * Ícono de ayuda (?) que despliega un tooltip.
 *
 * - Desktop: hover o foco con teclado.
 * - Táctil: tap (toggle).
 * - Solo uno abierto a la vez; se cierra al tocar fuera, re-tocar o con Esc.
 */
export function InfoTooltip({ content, label, position = 'top' }: InfoTooltipProps) {
  return (
    <Tooltip content={content} position={position}>
      <button type="button" className={styles.trigger} aria-label={label}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          className={styles.icon}
        >
          <path
            d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2Z"
            fill="currentColor"
          />
          <path
            d="M10.523 11.9145C10.4903 11.9472 10.4506 11.9635 10.404 11.9635H9.11596C9.06929 11.9635 9.02963 11.9472 8.99696 11.9145C8.96429 11.8819 8.94796 11.8422 8.94796 11.7955V11.2215C8.94796 10.7735 9.05996 10.4119 9.28396 10.1365C9.50796 9.8612 9.83463 9.56953 10.264 9.26153C10.6373 8.99086 10.9173 8.74586 11.104 8.52653C11.2906 8.3072 11.384 8.0342 11.384 7.70753C11.384 7.34353 11.258 7.05186 11.006 6.83253C10.754 6.6132 10.4226 6.50353 10.012 6.50353C9.58263 6.50353 9.23729 6.6202 8.97596 6.85353C8.71463 7.08686 8.58396 7.38553 8.58396 7.74953V8.04353C8.58396 8.1462 8.52796 8.19753 8.41596 8.19753L7.12796 8.14153C7.08129 8.14153 7.04163 8.12286 7.00896 8.08553C6.97629 8.0482 6.95996 8.0062 6.95996 7.95953V7.74953C6.95996 7.21753 7.09063 6.74386 7.35196 6.32853C7.61329 5.9132 7.97729 5.5912 8.44396 5.36253C8.91063 5.13386 9.44729 5.01953 10.054 5.01953C10.9593 5.01953 11.6826 5.25986 12.224 5.74053C12.7653 6.2212 13.036 6.8582 13.036 7.65153C13.036 8.0622 12.9636 8.41686 12.819 8.71553C12.6743 9.0142 12.5063 9.25686 12.315 9.44353C12.1236 9.6302 11.8646 9.8402 11.538 10.0735C11.2113 10.3069 10.9686 10.5099 10.81 10.6825C10.6513 10.8552 10.572 11.0675 10.572 11.3195V11.7955C10.572 11.8422 10.5556 11.8819 10.523 11.9145ZM10.418 14.6935C10.2313 14.8802 9.99796 14.9735 9.71796 14.9735C9.42863 14.9735 9.19063 14.8802 9.00396 14.6935C8.81729 14.5069 8.72396 14.2689 8.72396 13.9795C8.72396 13.6902 8.81729 13.4545 9.00396 13.2725C9.19063 13.0905 9.42863 12.9995 9.71796 12.9995C10.0073 12.9995 10.243 13.0905 10.425 13.2725C10.607 13.4545 10.698 13.6902 10.698 13.9795C10.698 14.2689 10.6046 14.5069 10.418 14.6935Z"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
          />
        </svg>
      </button>
    </Tooltip>
  );
}

InfoTooltip.displayName = 'InfoTooltip';
